import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { IPartiesRanking } from '@sky-it-elections/design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const PartiesRankingBlockWrapper = React.lazy(() => import('./candidates-parties-ranking'));
export interface IDynamicPartiesRankingBlock extends IComponentModel<IPartiesRanking> {}

const DynamicPartiesRankingBlock: React.FC<IDynamicPartiesRankingBlock> = ({
  /* istanbul ignore next: default value on mandatory field */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
}) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <PartiesRankingBlockWrapper initialModel={validateModel(model) as IPartiesRanking} query={validateModel(query)} />
  </Suspense>
);

DynamicPartiesRankingBlock.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  model: PropTypes.any,
  query: PropTypes.object,
};

DynamicPartiesRankingBlock.defaultProps = {
  children: null,
  model: {} as IPartiesRanking,
  query: {},
};

export default DynamicPartiesRankingBlock;
